/**
 * Project API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type DeliveryCategoryModel = 'NONE' | 'SMART_OFFERING' | 'SMART_PROJECT_FP' | 'SMART_PROJECT_TM' | 'SMART_AMS' | 'LEGACY_AMS' | 'SMART_RESOURCING_2_0' | 'LEGACY_PROJECT_FP' | 'LEGACY_PROJECT_TM' | 'LEGACY_RESOURCING';

export const DeliveryCategoryModel = {
    None: 'NONE' as DeliveryCategoryModel,
    SmartOffering: 'SMART_OFFERING' as DeliveryCategoryModel,
    SmartProjectFp: 'SMART_PROJECT_FP' as DeliveryCategoryModel,
    SmartProjectTm: 'SMART_PROJECT_TM' as DeliveryCategoryModel,
    SmartAms: 'SMART_AMS' as DeliveryCategoryModel,
    LegacyAms: 'LEGACY_AMS' as DeliveryCategoryModel,
    SmartResourcing20: 'SMART_RESOURCING_2_0' as DeliveryCategoryModel,
    LegacyProjectFp: 'LEGACY_PROJECT_FP' as DeliveryCategoryModel,
    LegacyProjectTm: 'LEGACY_PROJECT_TM' as DeliveryCategoryModel,
    LegacyResourcing: 'LEGACY_RESOURCING' as DeliveryCategoryModel
};

